import { types } from 'mobx-state-tree';

export default types
  .model('BankAccountSummary', {
    id: types.number,
    created_at: types.maybe(types.string),
    updated_at: types.maybe(types.string),
    bank_account: types.string,
    user_name: types.maybeNull(types.string),
    logo_type: types.string,
    is_verified: types.boolean,
    logo: types.maybeNull(types.string),
  })
  .views(self => ({
    get logo_src() {
      return `data:image/jpeg;base64,${self.logo}`;
    },
  }));
